import React from "react";
import { CompanyProfile } from "./models";

interface Props {
  profile: CompanyProfile
}

const ProfileRow = ({ profile }: Props) => {
  const profiles: string[] = [];

  if (profile.isArtist === "active") {
    profiles.push(site.currentEnvironment.functionGroups.artist.singular);
  } else if (profile.isArtist === "noLongerActive") {
    profiles.push(`${site.currentEnvironment.functionGroups.artist.singular} (${RESX.Artist.NoLongerActive})`);
  }

  if (profile.isVenue === "active") {
    profiles.push(site.currentEnvironment.functionGroups.venue.singular);
  }

  if (profile.isPromoter === "active") {
    profiles.push(site.currentEnvironment.functionGroups.promoter.singular);
  }

  if (profiles.length === 0) {
    return <></>;
  }

  return <div>
    {profiles.join(", ")}
  </div>
};

export default ProfileRow;